// extracted by mini-css-extract-plugin
module.exports = {"jobsListCard":"AppliedJobs_jobsListCard__3wY9E","jobInfo":"AppliedJobs_jobInfo__1u0et","applyBtn":"AppliedJobs_applyBtn__3RYAl"};